<template>
  <div class="youthlist min-w">

    <div class="topcon">
      <div class="carcon">
        <div is='titlebox' :nav='JSON.parse(nav)'></div>
      </div>
    </div>

    <div class="listcon">
      <div class="list">
        <!-- $util.goPage('/newDetail',23,item.id) -->
        <div class="signle" v-for="(item,index) in youthStudy" :key="index" @click.stop="openUrl">
          <div class="imgcon">
            <img :src="imgs[index-Math.floor(index/6)*6].src"/>
          </div>
          <div class="title">{{ item.title ? item.title : '' }}</div>
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <div class="block">
      <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="param.pageNo"
          :page-size="param.pageSize"
          layout="prev, pager, next, jumper"
          :total="param.total">
      </el-pagination>
    </div>

  </div>

</template>

<script>


export default {
  computed: {
    nav: function () {
      var arr = [
        {
          label: '聚焦青年',
          path: '/focusYouth',
        },
        {
          label: '青年大学习',
          path: '/jumppage/youthlist',
          type: 20
        }
      ]
      return JSON.stringify(arr)
    }
  },
  data: function () {
    return {
      youthStudy: [],
      param: {
        pageNo: 1,//分页
        pageSize: 6,
        total: 0,
      },
      imgs: [
        {src: require('../../assets/img/party/studyimg1.jpg')},
        {src: require('../../assets/img/party/studyimg2.jpg')},
        {src: require('../../assets/img/party/studyimg3.jpg')},
        {src: require('../../assets/img/party/studyimg4.jpg')},
        {src: require('../../assets/img/party/studyimg5.jpg')},
        {src: require('../../assets/img/party/studyimg6.jpg')},
      ]

    };
  },

  mounted() {
    this.$util.goTop()
    this.getYouthStudy()
  },

  methods: {
    openUrl() {
      window.open('https://h5.cyol.com/special/daxuexi/lduvrxfhae/index.html')
    },
    getYouthStudy() {//青年大学习
      var param = {
        pageNo: this.param.pageNo,//分页
        pageSize: this.param.pageSize,
        msgType: 13
      }
      this.$get('/web/information/list', param).then(res => {
        this.youthStudy = res.result.records;
        this.param.total = res.result.total
        console.log(this.param)
      })
    },
    handleSizeChange(val) {
      this.$util.goTop()
      console.log(`每页 ${val} 条`);
      this.param.pageSize = val;
      this.getYouthStudy()

    },
    handleCurrentChange(val) {
      this.$util.goTop()
      console.log(`当前页: ${val}`);
      this.param.pageNo = val;
      this.getYouthStudy()
    },


  },


};
</script>

<style scoped="scoped" lang="scss">

.youthlist {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  height: 100%;
  background: #ffffff;

  .topcon {
    display: flex;
    justify-content: center;

    .carcon {
      width: 1260px;
    }
  }

  .listcon {
    display: flex;
    justify-content: center;
    margin-top: 20px;

    .list {
      width: 1200px;
      display: flex;
      flex-wrap: wrap;
      margin-left: 30px;
    }

    .signle {
      margin-top: 40px;
      margin-left: 30px;
      width: calc(33.3% - 30px);

      .imgcon {
        width: 100%;
        height: 202px;
        overflow: hidden;

        img {
          cursor: pointer;
          width: 100%;
        }
      }

      .title {
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        font-weight: 400;
        padding: 0px 5px;
        color: #333333;
        cursor: pointer;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    .signle:nth-child(3n+1) {
      margin-left: 0px;
    }

    .signle:hover {
      transform: translateY(-10px);
      box-shadow: 5px 5px 8px rgba(0, 0, 0, 0.3);
    }

  }

  .block {
    text-align: center;
    line-height: 50px;
    margin-top: 20px;
  }


}

</style>
